// extracted by mini-css-extract-plugin
export default {"HelpText":"HelpText_HelpText__bXhi2"};